// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FilterDuration_wrapper_3tZ-uSP","label":"FilterDuration_label_jod4Vqp"};